import { icons } from "@tools";
import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.IconFilter,
    dependencies: [
    ]
})
export class IconFilter {
    constructor() {
        return ((key: string) => {
            if (key) key = key.toCamelCase();
            let icon = icons[key];
            if (!icon) {
                icon = key;
            }

            return icon;
        }) as any;
    }
}
